module.exports = __webpack_public_path__ + "img/p2.7633abf0.png";